import React from 'react'
import PropTypes from 'prop-types'

const Svg = (props) => {
  return (
    <svg className={props.className} viewBox={props.svg.viewBox}>
      <use xlinkHref={`#${props.svg.id}`} />
    </svg>
  )
}

Svg.propTypes = {
  svg: PropTypes.shape({
    id: PropTypes.string,
    viewBox: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
}

export default Svg
